import { render } from "./ChevronUpDown.vue?vue&type=template&id=f2d63056"
const script = {}
script.render = render

export default script